// src/pages/Login.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import { useBranding } from '../context/BrandingContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const { branding } = useBranding();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const r = await login(email, password);
      signIn(r.data.token, r.data.user);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div style={{ marginBottom: 28, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 700 }}>
            {branding.logo_url ? <img className="logo-img" src={branding.logo_url} alt={branding.brand_name} /> : <span className="logo-name">{branding.brand_name}</span>}
            
          </div>
          <div style={{ fontSize: 13, color: 'var(--gray-400)', marginTop: 4 }}>{branding.login_tagline || 'EMS — Sign in to continue'}</div>
        </div>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" autoFocus required />
          </div>
          <div className="form-group">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <label className="form-label" style={{ margin: 0 }}>Password</label>
              <Link to="/forgot-password" style={{ fontSize: 11, color: 'var(--primary)', textDecoration: 'none' }}>Forgot password?</Link>
            </div>
            <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
          </div>
          {error && <p className="error-text" style={{ marginBottom: 10 }}>{error}</p>}
          <button className="btn btn-primary" style={{ width: '100%', marginTop: 4, justifyContent: 'center' }} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p style={{ marginTop: 20, fontSize: 12, color: 'var(--gray-400)', textAlign: 'center' }}>
          New team member? Ask your admin for a setup link.
        </p>
        {/* Plain <a>, not <Link>: these are static files served outside the SPA,
            so react-router must not intercept them. Kept on the login screen
            because it is the one page reachable without an account — which is
            where a Meta reviewer (or anyone) looks for them. */}
        <p style={{ marginTop: 14, fontSize: 11, color: 'var(--gray-300)', textAlign: 'center' }}>
          <a href="/privacy" style={{ color: 'inherit' }}>Privacy</a>
          {' · '}
          <a href="/terms" style={{ color: 'inherit' }}>Terms</a>
          {' · '}
          <a href="/data-deletion" style={{ color: 'inherit' }}>Data Deletion</a>
        </p>
        {branding.powered_by_enabled === '1' && (
          <p style={{ marginTop: 12, fontSize: 11, color: 'var(--gray-300)', textAlign: 'center' }}>
            Powered by {branding.brand_name}
          </p>
        )}
      </div>
    </div>
  );
}
